import axios from "axios";
export default {
    methods: {
        requestNotificationPermission() {
            if (!('Notification' in window)) {
                console.log('This browser does not support notifications.');
                return;
            }
            if (Notification.permission === 'granted') {
                this.getSubscriptionData();
            } else  {
                Notification.requestPermission().then(permission => {
                    if (permission === 'granted') {
                        this.getSubscriptionData();
                    }
                });
            }
        },
        async getSubscriptionData() {
            localStorage.setItem('notificationSubscribed', 1)
            if ('serviceWorker' in navigator) {
                try {
                    await navigator.serviceWorker.register('/service-worker.js').then(async (registration) => {
                        setTimeout(async () => {
                            if ('PushManager' in window && registration.pushManager) {
                                const subscription = await registration.pushManager.subscribe({
                                    userVisibleOnly: true,
                                    applicationServerKey: process.env.VUE_APP_PUBLIC_VAPID_KEY
                                });
                                this.deviceData = subscription;
                                this.subscribeNotifications();
                            } else {
                                console.warn('PushManager is not available');
                            }
                        }, 1000);
                    }).catch(e => console.log(e));
                } catch (error) {
                    console.error('Service Worker registration failed:', error);
                }
            } else {
                console.warn('Service workers are not supported in this browser.');
            }
        },
        subscribeNotifications() {
            let data = {
                deviceData: this.deviceData,
                domainName: window.location.host,
            };
            axios.post('notification/subscribe-notification', data).then(response => {  // USER SERVER
                if (response) console.log(response);
            }).catch(error => {
                if (error) this.$toast.error(error?.message);
            });
        }
    }
};